import Button from '../../atoms/buttons/menuLoginButton';
import Container from '../../atoms/container/menuLoginContainer';
import Focus from '../../../../shared/types/enums/focus';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import useKeyboard from '../../../../shared/components/utils/hooks/useKeyboard';
import { loginAction } from '../../../../shared/actions/flow';
import { modalSelector } from '../../../../shared/store/slices/modal.slice';
import { updateParams } from '@shared/store/slices/router.slice';
import { useAppDispatch, useAppSelector } from '../../../../shared/store/hooks';
import { useCallback, useEffect, useState } from 'react';
import {
  appSelector,
  setLogin,
} from '../../../../shared/store/slices/app.slice';
import {
  filterFocus,
  focusSelector,
  popFocus,
  pushFocus,
} from '../../../../shared/store/slices/focus.slice';

function MenuLogin() {
  const dispatch = useAppDispatch();
  const {
    status: { description },
  } = useAppSelector(appSelector);
  const { focus } = useAppSelector(focusSelector);
  const { current: modal } = useAppSelector(modalSelector);
  const [display, setDisplay] = useState(false);
  const [focused, setFocused] = useState(false);
  const [render, setRender] = useState(false);

  // Event handlers

  const onClick = useCallback(() => {
    display && loginAction();
  }, [display]);

  const onPointerEnter = useCallback(() => {
    display && setFocused(true);
  }, [display]);

  const onPointerLeave = useCallback(() => {
    setFocused(focus === Focus.LOGIN);
  }, [focus]);

  // Effect hooks

  useEffect(() => {
    dispatch(setLogin(display));
  }, [display]);

  useEffect(() => {
    setFocused(focus === Focus.LOGIN);
  }, [focus]);

  useEffect(() => {
    // if (modal) return;
    setRender(focus !== Focus.SEARCH_KEYBOARD);
    setDisplay(
      [Focus.LOGIN, Focus.MENU].includes(focus as number) ||
        (!description &&
          [Focus.LOGIN, Focus.MAIN_EMPTY, Focus.MENU].includes(focus as number))
    );
  }, [description, focus, modal]);

  // Keyboard hook

  useKeyboard({
    focus: Focus.LOGIN,
    keyDownHandler: () => null,
    keyUpHandler: (key) => {
      switch (key) {
        case 'DOWN':
          dispatch(popFocus());
          break;
        case 'LEFT':
          dispatch(pushFocus(Focus.MENU));
          dispatch(filterFocus(Focus.LOGIN));
          break;
        case 'SELECT':
          dispatch(updateParams({ previousFocus: Focus.MENU }));
          loginAction();
          break;
      }
    },
  });

  return render ? (
    <Container
      animation={display ? 'menu-fade-in' : 'menu-fade-out'}
      force={true}
    >
      <Button
        focused={focused}
        onClick={onClick}
        onPointerEnter={onPointerEnter}
        onPointerLeave={onPointerLeave}
      >
        {TranslationManager.get('COMPONENTS.LOGIN')}
      </Button>
    </Container>
  ) : null;
}

export default MenuLogin;
